import React from 'react';

/**
 * LinhaDoTempo — eventos em ordem. itens: [{ id, dia, mesCurto, mes, titulo, texto?, etiquetas? }].
 * Itens com o mesmo `mes` seguidos ficam sob um cabeçalho de mês.
 * etiquetas: [{ rotulo, classe? }] ao lado do título (origem do andamento, por exemplo).
 */
export default function LinhaDoTempo({ itens, rotulo = 'Linha do tempo' }) {
  const grupos = [];
  itens.forEach((it) => {
    const ultimo = grupos[grupos.length - 1];
    if (ultimo && ultimo.mes === it.mes) ultimo.itens.push(it);
    else grupos.push({ mes: it.mes, itens: [it] });
  });

  return (
    <div aria-label={rotulo}>
      {grupos.map((g, i) => (
        <section key={`${g.mes}-${i}`}>
          <h3 className="sj-linha__mes">{g.mes}</h3>
          <ol className="sj-linha">
            {g.itens.map((it) => (
              <li key={it.id} className="sj-linha__item">
                <div className="sj-linha__data">
                  <span className="sj-linha__dia sj-num">{it.dia}</span>
                  <span className="sj-linha__mes-curto">{it.mesCurto}</span>
                </div>
                <div className="sj-linha__corpo">
                  <div className="sj-linha__topo">
                    <span className="sj-linha__titulo">{it.titulo}</span>
                    {(it.etiquetas || []).map((e) => <span key={e.rotulo} className={['sj-tipo', e.classe].filter(Boolean).join(' ')}>{e.rotulo}</span>)}
                  </div>
                  {it.texto && <span className="sj-linha__texto">{it.texto}</span>}
                </div>
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
}
